<template>
  <PageTemplate :loading="loading">
    <Institutional
      :title="item.title"
      :text="item.text"
      :images="images"
      v-if="item.title"
    />
  </PageTemplate>
</template>

<script>
import PageTemplate from "../templates/Page.vue";
import Institutional from "../templates/Institutional.vue";

const _config = {
  mod: "social",
};

export default {
  data: () => ({
    loading: true,
    item: {},
    images: [],
  }),
  computed: {
    itemId() {
      return this.$route.params.item.replace(/^.*-([0-9]+)$/, "$1");
    },
    sm() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    xs() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  methods: {
    get() {
      this.loading = true;

      this.$rest(_config.mod)
        .get({ id: this.itemId })
        .then((data) => {
          this.item = data;

          if (data.img.list.length)
            this.images = data.img.list.map(({ path }) => {
              return path ? this.files + path : "";
            });

          this.loading = false;
        })
        .catch(() => this.$router.replace("/error404"));
    },
  },
  watch: {
    itemId() {
      this.get();
    },
  },
  created() {
    this.get();
  },
  components: {
    PageTemplate,
    Institutional,
  },
};
</script>
